import { QBOperator } from '@/components/QueryBuilder/QueryBuilder.constants';
import type { QBFilter } from '@/components/QueryBuilder/QueryBuilder.types';
import { mapQBFiltersToAPIParams } from '@/components/QueryBuilder/QueryBuilder.utils';
import { parseTimeFilter } from '@/components/TimeFilter';
import type { TimePresetKeyWithField } from '@/components/TimeFilter/TimeFilter.types';
import { PONDURANCE_NAME } from '@/constants/common';

import { TICKET_THREAT_RESOLUTIONS_MAP } from '../Ticket';
import { CASE_REVIEW_STATUS } from './Cases.constants';
import type { CaseList } from './Cases.types';

export const getReviewedStatus = (
  message: string | null | undefined,
  priority: string | undefined
): CASE_REVIEW_STATUS => {
  if (!['P1', 'P2'].includes(priority || '')) {
    return CASE_REVIEW_STATUS.NA;
  }
  return message ? CASE_REVIEW_STATUS.COMPLETED : CASE_REVIEW_STATUS.PENDING;
};

export const mapCases = (cases: CaseList[]) =>
  cases.map((c) => {
    return {
      ...c,
      ai_priority: c.ai_priority?.split(' - ')[0] || '',
      category: (c.ticket?.ticket_category?.name as string) || '',
      managed: c.ai_managed ? 'managed' : 'not_managed',
      organization_name: c.organization?.name || '',
      scope_verdict:
        TICKET_THREAT_RESOLUTIONS_MAP[`${c.ticket?.resolution_id}`] || '',
      soc_priority: c.soc_priority?.split(' - ')[0] || '',
      ticket_priority: c.ticket?.priority_id ? `P${c.ticket.priority_id}` : '',
      soc_review_message: c.soc_review_message || ''
    };
  });

export const mapCaseFiltersToRequestParams = (
  caseFilters: QBFilter[],
  caseTimeFilter?: TimePresetKeyWithField | null
) => {
  const params: Record<string, string> = {};

  if (caseFilters && caseFilters.length > 0) {
    Object.entries(mapQBFiltersToAPIParams(caseFilters)).forEach(
      ([key, value]) => {
        const normalizedValues = String(value)
          .split(',')
          .map((item) => item.trim())
          .filter(Boolean);
        const isPonduranceOnlyAuthorFilter =
          key.includes('user__name') &&
          normalizedValues.length === 1 &&
          normalizedValues[0] === PONDURANCE_NAME;
        if (isPonduranceOnlyAuthorFilter) {
          const paramValue =
            !key.includes(QBOperator.Neq) && !key.includes(QBOperator.NotIn);
          params.user__internal = paramValue ? 'true' : 'false';
        } else {
          params[key] = value as string;
        }
      }
    );
  }

  if (caseTimeFilter) {
    const { from, to, column } = parseTimeFilter(caseTimeFilter);
    const timeFilterField = column === 'C' ? 'created_at' : 'updated_at';
    if (from) params[`${timeFilterField}__gte`] = from.toString();
    if (to) params[`${timeFilterField}__lte`] = to.toString();
  }

  return params;
};

export default mapCases;
